'use client';

import { useEffect } from 'react';
import { useUser } from '@clerk/nextjs';
import { reportXSignupConversion } from '@/lib/analytics/report-x-signup';

/**
 * 挂在根布局统一监听注册转化。
 * 注册可从 /sign-up、Studio 弹窗、Playground 弹窗发起，落地页各不相同，
 * 逐个页面接入必然漏报，这里改为登录态就绪后由创建时间判定。
 */
export function XSignupTracker() {
  const { isLoaded, isSignedIn, user } = useUser();

  const userId = user?.id;
  const createdAtMs = user?.createdAt?.getTime();
  const email = user?.primaryEmailAddress?.emailAddress ?? null;

  useEffect(() => {
    if (!isLoaded || !isSignedIn || !userId || !createdAtMs) return;

    const ac = new AbortController();
    void reportXSignupConversion({ userId, createdAtMs, email }, ac.signal);

    return () => ac.abort();
  }, [isLoaded, isSignedIn, userId, createdAtMs, email]);

  return null;
}
